import { Route, Routes } from "react-router-dom";
import { AdminCreateTripContainer } from "./createtrip/AdminCreateTripContainer";
import { LeadsContainer } from "./leads/LeadsContainer";
import { AllTripsContainer } from "./alltrips/AllTripsContainer";
import UsersListContainer from "./users/UsersListContainer";
import AddBlog from "./AddBlogs/AddBlog";
import AllReviews from "./reviews/AllReviews/AllReviews";
import CreateReview from "./reviews/CreateReview/CreateReview";
import AddSvg from "./Svg/AddSvg";
import { AddOrEditUserContainer } from "./users/AddOrEditUserContainer";
import Home from "../../Pages/Home/Home";
import { useUser } from "../../contextApi/userContext";
import AdminPanel from "./adminPanel/adminPanel";
import AdminPanelPages from "./AdminPanelPages";
import AdminLogin from "./adminPanel/adminLogin";

const AdminPages = () => {
  const userSetter = useUser();

  if (userSetter?.user?.role.includes("admin")) {
    return (
      <>
        <Routes>
          <Route path="/admin" element={<AdminPanel />} />
          <Route
            path="/admin/createtrip/:tripId"
            element={<AdminCreateTripContainer />}
          />
          <Route path="/admin/leads" element={<LeadsContainer />} />
          <Route
            path="/admin/createtrip/*"
            element={<AdminCreateTripContainer />}
          />
          <Route path="/admin/trips" element={<AllTripsContainer />} />
          <Route path="/admin/users" element={<UsersListContainer />} />
          <Route
            path="/admin/users/edit/:userId"
            element={<AddOrEditUserContainer />}
          />
          <Route path="/admin/blog" element={<AddBlog />} />
          <Route path="/admin/reviews" element={<AllReviews />} />
          <Route path="/admin/review/:id" element={<CreateReview />} />
          <Route path="/admin/createReview" element={<CreateReview />} />
          <Route path="/admin/svg" element={<AddSvg />} />
          <Route path="/*" element={<Home />} />
        </Routes>
      </>
    );
  } else {
    return (
      <>
        <Routes>
          <Route path="/admin-panel" element={<AdminLogin />} />
          <Route path="/*" element={<AdminPanelPages />} />
        </Routes>
      </>
    );
  }
};

export default AdminPages;
